<template>
  <div class="login-header">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'loginHeader',
  props: {
    title: {
      type: String,
      default: function () {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-header {
  height: 60px;
  background-color: #006bd3;
  border: solid 1px #797979;
  font-size: 18px;
  font-weight: 700;
  line-height: 60px;
  color: #FFFFFF;
  padding-left: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/loginHeader.vue